import React from 'react';
import { observer, inject } from 'mobx-react';
import PropTypes from 'prop-types';

const END_IF = '<![endif]-->';

export const IfIE = ({
  serverRender = false,
  comment = '',
  browsers = 'mso'
}) => {
  const element = (
    <i
      dangerouslySetInnerHTML={{
        __html: `<!--[if ${browsers}]>` + comment + END_IF
      }}
    />
  );
  return serverRender ? element : null;
};

IfIE.propTypes = {
  serverRender: PropTypes.bool,
  comment: PropTypes.string,
  browsers: PropTypes.string
};

export default inject('serverRender')(observer(IfIE));
